import { isObjectEqual } from '../../../../utils/Object';
import { useInsuranceProvider } from '../../components/InsuranceProviderCard/hooks/useInsuranceProvider';
import { useOfficeInformation } from '../../components/OfficeInformationCard/hooks/useOfficeInformation';
import { useOfficeProfile } from '../../components/OfficeProfileCard/hooks/useOfficeProfile';
import { useParking } from '../../components/ParkingCard/hooks/useParking/useParking';
import { useSoftware } from '../../components/SoftwareCard/hooks/useSoftware/useSoftware';

export const useFormStatus = ({ control, formValues, defaultValues }) => {
  const isDirty = !isObjectEqual(defaultValues, formValues);

  const { isValid: isOfficeValid, canSave: canSaveOffice } = useOfficeProfile(control);
  const {
    isValid: isOfficeInformationValid,
    canSave: canSaveOfficeInformation,
    hasWarning: hasOfficeInformationWarning,
  } = useOfficeInformation(control);
  const { isValid: isInsuranceProviderValid, canSave: canSaveInsuranceProvider } =
    useInsuranceProvider(control);
  const { isValid: isSoftwareValid, canSave: canSaveSoftware } = useSoftware(control);
  const { isValid: isParkingValid, canSave: canSaveParking } = useParking(control);

  const isValid =
    isOfficeValid &&
    isInsuranceProviderValid &&
    isSoftwareValid &&
    isOfficeInformationValid &&
    isParkingValid;

  // canSave gates the Save button: required fields only block when the user
  // touched them. Pre-existing missing values stay flagged in the UI (isValid)
  // but don't prevent saving unrelated edits.
  const canSave =
    canSaveOffice &&
    canSaveInsuranceProvider &&
    canSaveSoftware &&
    canSaveOfficeInformation &&
    canSaveParking;

  const isButtonDisabled = !isDirty || !canSave;

  return {
    isButtonDisabled,
    isDirty,
    isValid,
    hasWarning: hasOfficeInformationWarning,
  };
};
